// extracted by mini-css-extract-plugin
export default {"list":"kZ7HQyY3uk_landings"};